<template>
  <div class="home">

    <!-- Hero -->
    <div class="hero">
      <img src="@/assets/logo_selidaire.png" alt="SELIDAIRE" class="hero-logo">
      <p class="hero-tagline">
        Association de défense des intérêts des propriétaires de biens fonciers<br>
        concernés par l'exploitation minière du sel gemme<br>
        sous la ville de <strong>Varangéville</strong> et des territoires environnants.
      </p>
    </div>


    <!-- Latest articles -->
    <v-container class="section" v-if="latestsArticles.length">
      <h2 class="section-title">Dernières parutions</h2>
      <v-row justify="center" class="mt-4">
        <v-col
          v-for="article in latestsArticles"
          :key="article.eventid"
          cols="12" sm="6" md="4" lg="3"
        >
          <v-card :to="{ name: article.link }" class="article-card" elevation="2" rounded="lg">
            <v-img
              :src="article.picture || require('@/assets/logo_selidaire.png')"
              height="160"
              cover
              class="article-img"
            ></v-img>
            <v-card-text class="article-label">{{ article.title }}</v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Editorial -->
    <v-container class="section editorial">
      <v-row justify="center">
        <v-col cols="12" md="8">
          <v-card elevation="0" class="editorial-card" rounded="lg">
            <v-card-text>
              <p class="editorial-para">
                Toutes les exploitations minières de par le monde obéissent à une même logique.
                Dans un premier temps celles-ci sont profitables à tous, elles créent des emplois et des richesses.
              </p>
              <p class="editorial-para">
                Dans un deuxième temps les premiers désordres et impacts sur l'environnement,
                mais aussi sur les hommes, apparaissent. Ces désordres sont jugés comme acceptables
                et considérés comme largement compensés par les points positifs visés plus avant.
              </p>
              <p class="editorial-para">
                Dans un troisième temps, les impacts sur l'environnement et sur les populations
                deviennent de plus en plus lourds. Il faut alors regarder les choses en face et faire les comptes.
              </p>
              <p class="editorial-emphasis">
                Nous sommes maintenant dans cette troisième phase à Varangéville.
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
export default {
  data () {
    return {
      errors: [],
      latestsArticles: [],
      componentKey: 0,
    }
  },
  created () {
    this.getLatestEvent()
  },
  methods: {
    getLatestEvent () {
      this.$apiclient.getLatestEventByType()
        .then(response => {
          if (response.status !== 200) this.errors.push(response.statusText)
          this.latestsArticles = (response.data != null) ? response.data : []
          this.getLinks()
          this.getPictures()
        })
        .catch(error => {
          if (error.response === undefined) {
            this.errors.push('Error')
          } else if (error.response.status === 401) {
            this.errors.push("Vous n'êtes pas connecté ou non authorisé")
          } else {
            this.errors.push(error.response.statusText)
          }
        })
    },
    getPicture (pPath, id) {
      this.$apiclient.getPicture(pPath)
        .then(response => {
          this.componentKey += 1
          const bytes = new Uint8Array(response.data)
          let binary = ''
          for (let i = 0; i < bytes.length; i++) binary += String.fromCharCode(bytes[i])
          const img = btoa(binary)
          const uri = 'data:' + response.headers['content-type'] + ';base64,' + img
          this.latestsArticles[id].picture = uri
        })
        .catch(() => {})
    },
    getLink (eventtype) {
      switch (eventtype) {
        case 'Meeting': return 'Meetings'
        case 'Press': return 'Presse'
        case 'Publication': return 'Publications'
        case 'News': return 'News'
        default: return 'Home'
      }
    },
    getLinks () {
      for (var i = 0; i < this.latestsArticles.length; i++) {
        this.latestsArticles[i].link = this.getLink(this.latestsArticles[i].eventtype)
      }
    },
    getPictures () {
      for (var i = 0; i < this.latestsArticles.length; i++) {
        var picturePath = this.latestsArticles[i].picturepath
        if (picturePath !== '') this.getPicture(picturePath, i)
      }
    },
  }
}
</script>

<style scoped>
.home {
  background: #fafafa;
  min-height: 100vh;
}

/* Hero */
.hero {
  background: #ffffff;
  text-align: center;
  padding: 40px 24px 32px;
  border-bottom: 1px solid #e0e0e0;
}

.hero-logo {
  width: 90px;
  margin-bottom: 16px;
}

.hero-title {
  font-size: 1.2rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #212121;
  margin-bottom: 10px;
}

.hero-tagline {
  font-size: 0.95rem;
  line-height: 1.8;
  color: #555555;
  max-width: 640px;
  margin: 0 auto;
}

/* Sections */
.section {
  padding-top: 40px;
  padding-bottom: 40px;
}

.section-title {
  font-size: 1.2rem;
  font-weight: 700;
  text-align: center;
  color: #BF360C;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  position: relative;
}

.section-title::after {
  content: '';
  display: block;
  width: 48px;
  height: 3px;
  background: #E65100;
  margin: 10px auto 0;
  border-radius: 2px;
}

/* Article cards */
.article-card {
  transition: transform 0.2s, box-shadow 0.2s;
  cursor: pointer;
}

.article-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0,0,0,0.12) !important;
}

.article-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: #212121;
  line-height: 1.4;
  padding: 10px 12px;
}

/* Editorial */
.editorial-card {
  background: #ffffff;
  border-left: 4px solid #E65100;
  padding: 8px 0;
}

.editorial-para {
  font-size: 0.9rem;
  line-height: 1.8;
  color: #424242;
  margin-bottom: 14px;
  text-align: justify;
}

.editorial-emphasis {
  font-size: 0.95rem;
  font-weight: 700;
  color: #BF360C;
  text-align: center;
  margin-top: 8px;
  padding: 12px;
  background: #FFF3E0;
  border-radius: 6px;
}
</style>
